package de.oevbs.kunde.kundenportal2.services.contract.lineofbusiness

import de.oevbs.kunde.kundenportal2.components.inlineLink
import de.oevbs.kunde.kundenportal2.components.paragraph
import de.oevbs.kunde.kundenportal2.services.contract.detailsSection
import dev.fritz2.core.RenderContext

/**
 * Vertragsdetails der Sparte FDL Produkte
 * Details werden von den Kooperationspartnern gepflegt. Daher der Verweis für den Kunden.
 */
fun RenderContext.contractDetailsInvestment() {
    detailsSection("Ihr Versicherungsschutz") {
        paragraph {
            p {
                +"""Weitere Informationen über Ihren Vertrag erhalten Sie bei unserem Kooperationspartner der
                | Braunschweigischen Landessparkasse.""".trimMargin()
            }
            inlineLink(
                text = "http://www.blsk.de",
                link = "http://www.blsk.de",
                target = "_blank"
            )
        }
    }
}
